import SbuxStyledTableRow from "../../../../components/SbuxTable/SbuxStyledTableRow";
import SbuxStyledTableCell from "../../../../components/SbuxTable/SbuxStyledTableCell";

interface MyMetricsRowProps {
  row: Record<string, unknown>;
}

const MyMetricsRow = ({ row }: MyMetricsRowProps) => {
  return (
    <>
      <SbuxStyledTableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <SbuxStyledTableCell align="center">
          {String(row.contactsHandledTotal ?? "")}
        </SbuxStyledTableCell>
        <SbuxStyledTableCell align="center">
          {String(row.contactsHandledInbound ?? "")}
        </SbuxStyledTableCell>
        <SbuxStyledTableCell align="center">
          {String(row.contactsHandledOutbound ?? "")}
        </SbuxStyledTableCell>
        <SbuxStyledTableCell align="center">
          {String(row.contactsHandledCallback ?? "")}
        </SbuxStyledTableCell>
        <SbuxStyledTableCell align="center">
          {String(row.agentNonResponse ?? "")}
        </SbuxStyledTableCell>
        <SbuxStyledTableCell align="center">
          {String(row.avgAfterContactWorkTime ?? "")}
        </SbuxStyledTableCell>
        <SbuxStyledTableCell align="center">
          {String(row.avgHandleTime ?? "")}
        </SbuxStyledTableCell>
      </SbuxStyledTableRow>
    </>
  );
};

export default MyMetricsRow;
